export const {
    VUE_APP_TITLE,
    VUE_APP_API_DOMAIN,
    NODE_ENV,
    BASE_URL,
    VUE_APP_RESOURCES_DOMAIN,
    VUE_APP_MOCK_URL,
    VUE_APP_AMPLITUDE_ANALYTICS_KEY,
    VUE_APP_YM_COUNTER_ID,
    VUE_APP_BUILD_VERSION,
} = process.env as Record<string, string>

export const env = Object.freeze({
    APP_TITLE: VUE_APP_TITLE,
    API_DOMAIN: VUE_APP_API_DOMAIN,
    MOCK_URL: VUE_APP_MOCK_URL,
    RESOURCES_DOMAIN: VUE_APP_RESOURCES_DOMAIN,
    NODE_ENV,
    BASE_URL,
    AMPLITUDE_ANALYTICS_KEY: VUE_APP_AMPLITUDE_ANALYTICS_KEY,
    YM_COUNTER_ID: VUE_APP_YM_COUNTER_ID,
    BUILD_VERSION: VUE_APP_BUILD_VERSION,
})

if (env.NODE_ENV === 'development' && console.table) {
    console.table(env)
}
